// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"90701f7f","336":"2da13e5f","404":"7c4c4410","489":"008728fd","586":"10046c25","720":"f111e304","927":"1ee5b37a"}[chunkId] + ".chunk.js";
};